<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="700px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>Pridėti DVS duomenis</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2">
          <v-card-text class="mb-0 pb-0">
            <v-row class="mb-3">
              <v-col cols="12" md="6">
                <el-text-field
                  readonly
                  label="Ataskaitos Nr."
                  v-model="item.ata_id"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  readonly
                  label="Susijusio registro objektas"
                  v-model="item.ata_tipas"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  label="DVS Nr."
                  tooltip="Ataskaita. Registrai. DVS Nr."
                  v-model="item.ata_dvs_nr"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-date-picker
                  label="Išsiuntimo DVS data"
                  tooltip="Ataskaita. Registrai. Išsiuntimo DVS data"
                  v-model="item.ata_dvs_data"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button :loading="loading" @click.native.stop="closeModal()">
          Atšaukti
        </el-button>
        <el-button :loading="loading" primary @click.native="saveData()">
          Saugoti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import registrasTipasList from '../ataskaita/registrasTipasList'

export default {
  name: 'ModalAtaskaitaRegistraiDvs',
  props: {
    value: Boolean,
    item: Object,
  },
  mixins: [registrasTipasList],
  data() {
    return {
      loading: false,

      ata_laikotarpis_data_nuo: null,
      ata_laikotarpis_data_iki: null,
      ata_laikotarpis_laikas_nuo: '00:00',
      ata_laikotarpis_laikas_iki: '23:59',
      ata_tipas: null,
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  created() {
    //
  },
  methods: {
    saveData() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true

          this.$emit('confirmDvs', this.item)
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    closeModal() {
      this.showModal = false
    },
    submit() {
      this.saveData()
    },
    cancel() {
      this.closeModal()
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
